__turbopack_context__.v({
  "cardList": "xdbQXq_cardList",
  "desktopControlsRow": "xdbQXq_desktopControlsRow",
  "listSection": "xdbQXq_listSection",
  "mobileControls": "xdbQXq_mobileControls",
  "toggleSlot": "xdbQXq_toggleSlot",
  "unitDesktop": "xdbQXq_unitDesktop",
  "unitMobile": "xdbQXq_unitMobile",
});
